import { useEffect, useRef } from 'react';

/**
 * Tự cuộn tới element ngay khi nó xuất hiện, dùng cho các khối cảnh báo mà khách
 * dễ bỏ sót vì nằm ngoài vùng nhìn thấy.
 *
 * Chỉ cuộn MỘT lần cho mỗi lần xuất hiện: isShow giữ nguyên true qua các lần
 * re-render sẽ không cuộn lại, tránh giật màn hình khi khách đang thao tác. Cờ được
 * reset khi isShow về false nên khối ẩn rồi hiện lại vẫn cuộn tiếp.
 *
 * @param {boolean} isShow điều kiện render của chính element gắn ref
 * @returns ref để gắn vào element cần cuộn tới
 */
const useScrollIntoViewOnShow = (isShow) => {
  const ref = useRef(null);
  const hasScrolledRef = useRef(false);

  useEffect(() => {
    if (!isShow) {
      hasScrolledRef.current = false;
      return;
    }
    if (hasScrolledRef.current || !ref.current) return;
    hasScrolledRef.current = true;
    ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, [isShow]);

  return ref;
};

export default useScrollIntoViewOnShow;
